import gsap from 'gsap'
import barba from '@barba/core'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { initLenis, scrollTo, scrollToStart } from './lenis'
import { animation } from './animation'
import { swiper } from './swiper'
import { navigation } from './navigation'
import { insights } from './insights'
import { setThemeOnScroll, setThemeOnNavigate } from './theme'
import { projects } from './projects'
import { once } from './once'
import { footer } from './footer'
import { home } from './home'
import { slider } from './slider'
// import { cursorMovement, cursorEvents } from './cursor'
import { accordion } from './accordion'
import { forms } from './forms'
import { logotypeParallax } from './header'

gsap.registerPlugin(ScrollTrigger)

const initBarba = () => {

	barba.init({
		debug: false,
		timeout: 10000,
		schema: {
			prefix: 'data-load'
		},
		transitions: [
			{
				name: 'basic-transition',
				sync: true,
				once(data) {
					setThemeOnNavigate(data.next.namespace)
					document.body.setAttribute('data-current-namespace', data.next.namespace)
					setTimeout(() => scrollToStart(), 200);
				},
				leave(data) {
					const done = this.async()
					document.body.removeAttribute('data-navigation-status')
					document.body.setAttribute('data-transition-status', 'active')
					if (data.next.namespace == 'homepage' || data.next.namespace == 'insights') {
						document.body.setAttribute('data-shutter-theme', 'black')
					} else {
						document.body.setAttribute('data-shutter-theme', 'white')
					}
					setTimeout(() => setThemeOnNavigate(data.next.namespace), 400);
					setTimeout(() => done(), 650);
				},
				enter(data) {
					ScrollTrigger.killAll()
					document.body.setAttribute('data-current-namespace', data.next.namespace)
					setTimeout(() => {
						const done = this.async()
						scrollToStart()
						document.body.removeAttribute('data-transition-status')
						done()
					}, 650)
				}
			}
		]
	})

	barba.hooks.once((data) => {
		once(data.next.namespace)
		initLenis()
		setTimeout(() => animation(), 200);
		setTimeout(() => home(), 2000);
		navigation()
		swiper()
		insights()
		projects()
		setThemeOnScroll()
		footer()
		slider()
		// cursorMovement()
		// cursorEvents()
		accordion()
		forms()
	})

	barba.hooks.after((data) => {
		setTimeout(() => animation(), 200);
		setTimeout(() => {
			swiper()
			insights()
			projects()
			home()
			setThemeOnScroll()
			logotypeParallax()
			footer()
			slider()
			// cursorEvents()
			accordion()
			scrollTo()
			forms()
		}, 200);
	})
}

export default initBarba